import t from "../../../../../helpers/t";
import React, {useEffect, useState} from "react";
import {locationActions, taskActions, userActions, useSelector} from "inbooma-api";
import {Biscuit} from "../../../../../../utils";

const LocationsSelect = (props) => {
    const { user, dispatch, setTasksPending, tasksPending, language} = props;
    const _locations = useSelector(state => state.locations_data.locations);

    const [locationsResults, setLocationsResults] = useState([]);
    const [locationResultsHidden, setLocationResultsHidden] = useState(true);
    const [locationsPending, setLocationsPending] = useState(false);


    useEffect(() => {
        if(_locations.success !== '' || locationsPending) return;
        if (Biscuit.get('user.role') === 'admin') {
            dispatch(locationActions.getLocations({
                token: Biscuit.get('token'),
                filter: {
                    'find': 'short',
                    'limit': '999',
                    'sort': 'name',
                    'sortDirection': 'asc'
                }
            }));
            setLocationsPending(true);
        }
    }, []);

    useEffect(() => {
      if(_locations.success === '' || !locationsPending || tasksPending) return;
        if (_locations.success === true) {
            if (user.role === 'user') {
                dispatch(taskActions.getTasks({
                    filter: {
                        includes: "Users",
                        fk_model: "Users",
                        fk_id: user.id,
                    },
                    parameters: {
                        headers: {
                            "Accept-Language": language
                        }
                    },
                    token: Biscuit.get('token')
                }));
                setTasksPending(true);

            } else {
                dispatch(taskActions.getTasks({
                    filter: {
                        includes: "Users",
                        assignee: user.id
                    },
                    parameters: {
                        headers: {
                            "Accept-Language": language
                        }
                    },
                    token: Biscuit.get('token')
                }));
                setTasksPending(true);
            }
            setLocationsResults([..._locations.data]);
        }
        setLocationsPending(false);
    }, [_locations]);




    const isLocationSelected = (id) => {

        for (let i = 0; i < user.user_locations.length; i++) {
            if (user.user_locations[i].location_id === id) return true;
        }
        return false;
    };

    const getLocationById = (id) => {

        if (typeof _locations.data === 'undefined' || _locations.data == null) return '';

        for (let i = 0; i < _locations.data.length; i++) {
            if (_locations.data[i].id === id) return _locations.data[i].name;
        }
        return '';
    };

    const onLocationSearchClicked = (e) => {
        document.getElementsByClassName('select2-search__field')[0].style.width = "9em";
        document.getElementsByClassName('select2-search__field')[0].focus();
        setLocationsResults([..._locations.data]);
        setLocationResultsHidden(false);
    };

    const onLocationSearchChanged = (e) => {

        const value = e.target.value;
        let results = [];

        if (value.length == 0) {
            setLocationsResults([..._locations.data]);
        } else {
            results = [];
            // search for locations with name starting with query (value)
            for (var i = 0; i < _locations.data.length; i++) {
                if (_locations.data[i].name.toLowerCase().startsWith(value)) results.push(_locations.data[i]);
            }
            setLocationsResults(results);
        }
    };

    const onLocationSearchBlur = (e) => {
        setTimeout(() => {
            setLocationResultsHidden(true);
            document.getElementsByClassName('select2-search__field')[0].value = "";
        }, 200);
    };

    const onLocationsSelectHandle = (e, location) => {
        // add selection to array if not already selected
        if (!e.target.parentNode.classList.contains("selected")) {
            user.user_locations.push({
                location_id: location.id
            });
        };
    };

    const onLocationRemove = (e, location, index) => {

        user.user_locations.splice(index, 1);
    };

    return (
        <><div className="inb-form-group column medium-12 small-12 _backform_user_locations">
        <label className="inb-form__controlLabel">{t('location_list_manager')}</label>
        <div className="inb-form__controllClass">
            {typeof _locations.success !== 'undefined' && _locations.success === true &&
                <>
                                        <span
                                            className="select2 select2-container select2-container--default select2-container--focus"
                                            dir="ltr" data-select2-id="2" style={{ width: 'auto' }}>
                                            <span className="selection">
                                                <span className="select2-selection select2-selection--multiple" role="combobox"
                                                      aria-haspopup="true" aria-expanded="false" tabIndex="-1">
                                                    <ul className="select2-selection__rendered"
                                                        onClick={onLocationSearchClicked}>
                                                        {user.user_locations.map((loc, index) => {
                                                            const name = getLocationById(loc.location_id);
                                                            return (<>
                                                                    <li className="select2-selection__choice" title={name}>
                                                                    <span className="select2-selection__choice__remove"
                                                                          role="presentation" onClick={(e) => {
                                                                        onLocationRemove(e, loc, index)
                                                                    }}>×</span>
                                                                        {name}
                                                                    </li></>
                                                            );
                                                        })}

                                                        <li className="select2-search select2-search--inline" style={{ paddingTop: "5px" }}>
                                                            <input className="select2-search__field" type="search" tabIndex="0"
                                                                   autoComplete="off" autoCorrect="off" autoCapitalize="none"
                                                                   spellCheck="false"
                                                                   role="textbox" aria-autocomplete="list" placeholder={t('switch')}
                                                                   onChange={onLocationSearchChanged}
                                                                   onBlur={onLocationSearchBlur} />
                                                        </li>
                                                    </ul>
                                                </span>
                                            </span>
                                            <ul className={'inbooma-select-box-results' + (locationResultsHidden === true ? ' hide' : '')}
                                                style={{ width: '100%' }}>
                                                {locationsResults.map(location => {
                                                    return (
                                                        <li className={"inbooma-select-box-results__field" + (isLocationSelected(location.id) ? ' selected' : '')}
                                                            key={location.id} value={location.id}
                                                            onClick={(e) => {
                                                                onLocationsSelectHandle(e, location)
                                                            }}>
                                                            <span style={{ width: '100%' }}>{location.name}</span>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </span>
                </>
            }
        </div>
        <span className="help-text">{t('location_list_manager_help')}</span>
    </div></>);
}

export default LocationsSelect;